module.exports = __webpack_public_path__ + "static/media/2-hour.b15c13c7.png";